"use client";

import Link from "next/link";
import ShopFullwidth from "@/components/shop/ShopFullwidth";
import PageHeading from "@/components/common/PageHeading";
import { useProductListing } from "@/utlis/useProductListing";
import { useT } from "@/context/I18nContext";

const BASE_PARAMS = { onlyDiscounted: true };

export default function ReduceriClient({ initialData }) {
	const { state, handleFilterChange, handleLoadMore } = useProductListing(BASE_PARAMS, initialData);
	const { t } = useT();

	return (
		<>
			<div className='tf-page-title'>
				<div className='container-full'>
					<nav aria-label='breadcrumb' className='text-center mb_10'>
						<Link href='/'>{t("acasa")}</Link> / <span>{t("reduceri")}</span>
					</nav>
					<h1 className='heading text-center'>{t("reduceri_heading")}</h1>
				</div>
			</div>
			<PageHeading />
			<ShopFullwidth
				productsData={state.products}
				currentPage={state.currentPage}
				totalPages={state.totalPages}
				totalCount={state.totalCount}
				loading={state.loading}
				loadingMore={state.loadingMore}
				onLoadMore={handleLoadMore}
				onFilterChange={handleFilterChange}
			/>
		</>
	);
}
